<template>
  <div class="fondo_transparente">
    <div class="ventana_modal" v-show="verRegistro">
      <XCerrarModal @click="cerrar" id="XCerrar"/>
      <div class="ingreso">
        <div class="textoIngreso">Registro</div>
      </div>
      <form class="entradas">
        <input
          type="text"
          v-model="datRegistro.nombre"
          name="nombre"
          ref="nombre"
          class="entrada"
          placeholder="*NOMBRE"
          autocomplete="off"
          @keyup.enter="validarNombre (datRegistro.nombre)"
          @change="validarNombre (datRegistro.nombre)"
        >
        <input
          type="text"
          v-model="datRegistro.apellidos"
          name="apellido"
          ref="apellido"
          class="entrada"
          placeholder="APELLIDO"
          :disabled="disabEmail"
          autocomplete="off"
          @keydown.enter="enterEnApellido ()"
        >
        <input
          type="email"
          v-model="datRegistro.email"
          name="correo"
          ref="email"
          class="entrada"
          placeholder="*E-MAIL"
          :disabled="disabEmail"
          @blur="validarEmail (datRegistro.email)"
          @keyup.enter="validarEmail (datRegistro.email)"
          required
        >
        <input
          :type="modoPass"
          v-model="datRegistro.pass"
          name="pass1"
          ref="pass1"
          class="entrada"
          placeholder="*PASSWORD"
          :disabled="disabPass"
          @change="validarPassword(datRegistro.pass)"
          @keyup.enter="validarPassword(datRegistro.pass)"
        >
        <p class="ojo" @click="verPass">&gtcc;</p>
        <input
          type="password"
          v-model="pass2"
          name="pass2"
          ref="pass2"
          class="entrada"
          placeholder="*Reescribe el PASSWORD"
          :disabled="disabPass2"
        >
      <!-- @blur="validarPassword2()" -->
      </form>
      <div class="pieLogin">
        <div class="pieAux">
          <div class="irLogin" @click="irIngreso">Ir a INGRESO</div>
        </div>
        <button
          class="entrar"
          @click="enviarMail"
          :disabled="disabSend">
          ENVIAR
        </button>
      </div>
    </div>
    <div class="ventana_modal" v-show="verEnterPin">
      <XCerrarModal @click="cerrar" id="XCerrar"/>
      <div class="ingreso">
        <div class="textoIngreso">Validar e-mail</div>
      </div>
      <input
        type="text"
        v-model="pin"
        name="pin"
        ref="pin"
        class="entrada"
        placeholder="PIN de validación"
      >
      <div class="pieLogin">
        <div class="pieAux">{{msgCode}}</div>
        <button
          class="entrar"
          @click="registro"
          :disabled="disabEnv">
          ENVIAR
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import XCerrarModal from './XCerrarModal.vue'
export default {
  components: { XCerrarModal },
  name: 'Registro',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
  },
  mounted () {
    this.$refs.nombre.focus() // para poner el cursor en este campo al iniciar
  },
  data () {
    return {
      modoPass: 'password',
      datRegistro: {
        email: '',
        pass: '',
        nombre: '',
        apellidos: ''
      },
      pass2: '',
      URLbase: '',
      verRegistro: true,
      verEnterPin: false,
      // msgEmail: 'Se enviará un e-mail a esta dirección con un PIN',
      msgCode: 'Escribe el PIN enviado a tu e-mail para continuar el registro',
      inputCodeReg: false,
      pin: ''
    }
  },
  methods: {
    cerrar () {
      this.$router.push('/')
    },
    irIngreso () {
      this.$router.push('/login')
    },
    enviarMail () {
      if (this.validarPassword2() === 'fail') { return }
      const url = `${this.URLbase}/send-mail`
      axios.post(url, { email: this.datRegistro.email, caso: 'registro' })
        .then(result => {
          if (result.data === 'success') {
            this.verRegistro = false
            this.verEnterPin = true
          }
        })
    },
    registro () {
      try {
        const url = `${this.URLbase}/users/registro`
        const datReg = { pin: this.pin, datRegistro: this.datRegistro }
        axios.post(url, datReg)
          .then(result => {
            console.log(result.data)
            switch (result.data) {
              case 'fail':
                this.alertJoa('Error de servidor, reinicia la aplicación e intenta otra vez', 'E')
                this.$router.push('/')
                break
              case 'success':
                this.alertJoa('Usuario registrado con éxito. Puedes ingresar a la aplicación.', 'S')
                this.$router.push('/')
                break
              case 'failPIN':
                this.alertJoa('El pin no es correcto, intenta otra vez', 'W')
                this.pin = ''
                break
            }
          })
          .catch(error => console.log(error))
      } catch (error) {
        console.log(error)
      }
    },
    validarNombre (nombre) {
      if (nombre.length === 1 || nombre.length > 30) {
        this.datRegistro.nombre = ''
        // alert('El nombre debe contener al menos dos caracteres y no más de 30')
        this.alertJoa('El nombre debe contener al menos dos caracteres y no más de 30', 'W')
        this.$refs.nombre.focus() // no funciona
      } else {
        this.$refs.apellido.focus() // si funciona
      }
    },
    enterEnApellido () {
      this.$refs.email.focus()
    },
    async validarEmail (mail) {
      if (this.formatoCorrecto(mail)) {
        const url = `${this.URLbase}/users/veriMail`
        axios.post(url, { email: mail })
          .then(result => {
            if (result.data === 'noRegistrado') {
              // this.habSend = true
              this.$refs.pass1.focus()
            } else {
              this.alertJoa('El e-mail introducido ya está registrado', 'W')
              this.datRegistro.email = ''
            }
          })
      } else {
        if (this.datRegistro.email) {
          this.alertJoa('El formato del e-mail no es correcto', 'W')
        }
      }
    },
    validarPassword (password) {
      if (this.checkPassword(password)) {
        this.$refs.pass2.focus()
      } else {
        this.alertJoa('La contraseña debe contener (como mínimo) un número, una minúscula, una mayúscula y seis caracteres', 'W')
        this.$refs.pass1.focus()
      }
    },
    verPass () {
      this.modoPass = 'text'
      setTimeout(() => { this.modoPass = 'password' }, 2500)
    },
    validarPassword2 () {
      if (this.datRegistro.pass !== this.pass2) {
        this.pass2 = ''
        this.alertJoa('Las contraseñas no coinciden', 'W')
        this.$refs.pass2.focus()
        return 'fail'
      }
    },
    formatoCorrecto (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    checkPassword (pass) {
      // mínimo un número, una minúscula y una mayúscula
      // mínimo seis caracteres
      var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/
      return re.test(pass)
    }
  },
  computed: {
    disabSend () {
      return !(!!this.datRegistro.nombre && !!this.datRegistro.email && !!this.datRegistro.pass && !!this.pass2)
    },
    disabEmail () {
      return !(this.datRegistro.nombre)
    },
    disabPass () {
      return !(this.datRegistro.email)
    },
    disabPass2 () {
      return !(this.datRegistro.pass)
    },
    disabEnv () {
      return !(this.pin)
    }
  }
}
</script>

<style scoped>
.ventana_modal{
    /* background: -webkit-linear-gradient(115deg, rgb(180, 180, 180),rgb(214, 214, 214),rgb(180, 180, 180), rgb(68, 68, 68)); */
    width: 450px;
    /* height: 350px; */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    border-radius: 5px;
    /* display: grid; */
    display: flex;
    flex-direction: column;
    /* grid-template-rows: 31% 48% 21%; */
    justify-items: center;
    align-items: space-around;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    /* border:  1px solid rgb(179, 179, 179) */
}
.ingreso{
  height: 110px;
  background-color: rgba(10, 90, 140, 0.5);
  justify-self: stretch;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  /* border: solid 1px rgb(130, 238, 130); */
  display:grid
}
.textoIngreso{
  justify-self: left;
  align-self: center;
  margin-left: 8%;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 45px;
  font-weight: lighter;
  padding-bottom: 5px;
  color:rgb(251, 155, 82)
}
.entradas{
  justify-self: stretch;
  display: grid;
  row-gap: 1px;
}
.entrada{
  /* border: solid 1px rgb(130, 238, 130); */
  height: 32px;
  justify-self: stretch;
  margin: 0px;
  padding: 2px;
  padding-left: 8%;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 18px;
  background-color: rgb(250, 248, 242);
  outline:none;
  border:none;
}
.entrada:focus{
  outline:none
}
.ojo{
  position: absolute;
  color:rgba(10, 90, 140, 0.5);
  font-size: 20px;
  top: 56.5%;
  right: 20px;
}
.ojo:hover{
  cursor: pointer;
}
.pieLogin{
  height: 65px;
  display:grid;
  /* border: solid 1px rgb(130, 238, 130); */
  grid-template-columns: 55% 45%;
  justify-self: stretch;
  background-color: rgba(10, 90, 140, 0.5);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight:400;
}
.pieAux{
  display:flex;
  flex-direction: column;
  /* grid-template-rows: 50% 50%; */
  /* align-items: center; */
  justify-content: space-evenly;
}
.irLogin{
  /* border: solid 1px rgb(130, 238, 130); */
  width: 80%;
  align-self: center;
  border-radius:20px;
  /* background-color: rgba(1, 117, 163, 0.3); */
  color: rgb(251, 155, 82);
  padding: 1.5% 0%;
  border: solid 1px rgba(1, 117, 163, 0);
  cursor: pointer;
}
.irLogin:hover:hover{
  /* background-color: rgba(1, 117, 163, 0.5); */
  border: solid 1px rgba(10, 90, 140, 0.7);
}
.pieAux{
  display:flex;
  flex-direction: column;
  /* grid-template-rows: 50% 50%; */
  /* align-items: center; */
  justify-content: space-evenly;
  text-shadow: 1px 1px black;
}
.entrar{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  align-self: center;
  font-size: 20px;
  font-weight: lighter;
  width: 80%;
  height: 50%;
  border-radius:50px;
  padding: 1% 1% 1% 1%;
  color:rgb(251, 155, 82);
  background-color: rgba(1, 117, 163, 0);
  border: solid 1px rgba(1, 117, 163, 0);
  cursor: pointer;
  align-items: center;
}
.entrar:disabled{
  color:darkgrey;
}
.entrar p {
  margin:auto;
  -moz-transition: all 0.5s ease-out;
  -webkit-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
}
.entrar:hover:enabled{
  /* background-color: rgba(1, 117, 163, 0.4); */
  border: solid 1px rgba(10, 90, 140, 0.7);
}
.entrar:hover p{
  transform: translateY(-5px);
}
@media screen and (max-width: 576px){
  .ventana_modal{
    width: 90%;
    height: 380px;
    grid-template-rows: 28% 52% 20%;
    justify-items: center;
    align-items: space-around;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    /* border:  1px solid rgb(179, 179, 179) */
}
  .container{
    display: flex;
    flex-direction: column;
    font-size: 1rem
  }
}
</style>
